const get_user = () =>
{
    return localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : null
}

const BasicMixins = {

    methods: {

        unshift_object(array_object, new_object)
        {
            array_object.unshift(new_object)
        },

        modal_update(object)
        {
            this.update_mode = true
            this.global_index = object.index
            this.single_object = object.value
            window.$(`#${object.tag_name}`).modal('show')
        },

        splice_object(array_object, splicing_object)
        {
            array_object.splice(splicing_object.index, 1, splicing_object.single_object)
        },

        has_role(role)
        {
            const user = get_user();
            for (const rol of user.roles) {
                if(role === rol.name) {
                    return true;
                }
            }
            return false;
        },

        has_permission(permission)
        {
            const user = get_user();
            for (const rol of user.roles) {
                for (const permission_iterator of rol.permissions) {
                    if(permission === permission_iterator.name) {
                        return true;
                    }
                }
            }
            return false;
        },
        hasPermissions(permissions)
        {
            const user = get_user();
            const permissions_array = user.permissions;
            for (const permission of permissions) {
                for (const permission_iterator of permissions_array) {
                    if(permission === permission_iterator) {
                        return true;
                    }
                }
            }
        }

      
    },

}

export default BasicMixins
